var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Suspense } from "react";
import { isFunction, isLazyComponent, isMemoizedComponent, isReactComponent } from "./typeChecks.utils";
export var renderRenderable = function (R, props, fallback) {
    var _a;
    if (isMemoizedComponent(R))
        return React.createElement(R, __assign({}, props));
    if (isLazyComponent(R))
        return React.createElement(Suspense, { fallback: (_a = renderRenderable(fallback)) !== null && _a !== void 0 ? _a : 'Loading...', children: React.createElement(R, __assign({}, props)) });
    if (isReactComponent(R))
        return React.createElement(R, __assign({}, props));
    if (isFunction(R))
        return R(props);
    return R;
};
